import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User edits inactivity logout duration (assumes feature is already enabled)',
  name: 'edited_inactivity_logout_duration',
  params: [
    {
      description: 'Timeout period (in seconds)',
      name: 'inactivity_logout_timeout_duration',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
